import { RootState } from '../Store';
export const selectFilter = (state: RootState) => state.Filter;